import { invokeApi } from "../utils";

export const getPermissionGroupsApi = (page = 1) =>
  invokeApi({ path: "/permission-groups", method: "GET", queryParams: { page } });

export const createPermissionGroupApi = (postData) =>
  invokeApi({ path: "/permission-groups", method: "POST", postData });

export const getPermissionGroupByIdApi = (id) =>
  invokeApi({ path: `/permission-groups/${id}`, method: "GET" });

export const updatePermissionGroupApi = (id, postData) =>
  invokeApi({ path: `/permission-groups/${id}`, method: "PUT", postData });

export const deletePermissionGroupApi = (id) =>
  invokeApi({ path: `/permission-groups/${id}`, method: "DELETE" });
